export default __webpack_public_path__ + "static/media/zigzag_path.17bbfd33.jpg";